import {
  CanvasComponent,
  GraphComponent,
  GraphItemTypes,
  Point,
} from '@ardoq/yfiles';
import { isEdge, isNode } from '@ardoq/graph';

export const getToggleGraphNodeSelection =
  (commands: {
    toggleIsSelectedGraphNode: (graphNodeId: string) => void;
    // Selecting edges is only used in the filters tab - so the command is optional here
    toggleIsSelectedGraphEdge?: (graphEdgeId: string) => void;
  }) =>
  (event: React.MouseEvent) => {
    const graphNodeId = getGraphNodeIdFromEventTarget(event);

    if (graphNodeId) {
      commands.toggleIsSelectedGraphNode(graphNodeId);
    } else {
      const graphEdgeId = getGraphEdgeIdFromEventTarget(event);

      if (graphEdgeId) {
        commands.toggleIsSelectedGraphEdge?.(graphEdgeId);
      }
    }
  };

export const getGraphNodeOnHover = (commands: {
  onGraphNodeHover: (graphNodeId: string | null) => void;
}) => {
  let lastHoveredNode: string | null = null;
  return (event: React.MouseEvent) => {
    const graphNodeId = getGraphNodeIdFromEventTarget(event);
    if (graphNodeId !== lastHoveredNode) {
      lastHoveredNode = graphNodeId;
      commands.onGraphNodeHover(graphNodeId);
    }
  };
};

const getGraphHitElementFromEventTarget = (
  event: React.MouseEvent,
  typeFilter: GraphItemTypes
) => {
  const eventTarget = event.target;
  if (!(eventTarget instanceof Element)) return null;

  const graphComponent = CanvasComponent.getComponent(
    eventTarget.closest('.yfiles-canvascomponent')
  );
  if (!(graphComponent instanceof GraphComponent)) {
    return null;
  }
  const {
    graphModelManager,
    renderTree: { contentGroup },
  } = graphComponent;
  const location = graphComponent.pageToWorldCoordinates(
    new Point(event.clientX, event.clientY)
  );
  const [hitElement] = graphModelManager.hitElementsAt({
    location,
    root: contentGroup,
    typeFilter,
  });
  if (!hitElement) {
    return null;
  }
  return hitElement;
};

const getGraphNodeIdFromEventTarget = (event: React.MouseEvent) => {
  const hitElement = getGraphHitElementFromEventTarget(
    event,
    GraphItemTypes.NODE
  );
  if (!hitElement) {
    return null;
  }
  const { tag: graphNode } = hitElement;
  if (!isNode(graphNode)) {
    return null;
  }
  const { id } = graphNode;
  return id;
};

const getGraphEdgeIdFromEventTarget = (event: React.MouseEvent) => {
  const hitElement = getGraphHitElementFromEventTarget(
    event,
    GraphItemTypes.EDGE
  );
  if (!hitElement) {
    return null;
  }
  const { tag: graphEdge } = hitElement;
  if (!isEdge(graphEdge)) {
    return null;
  }
  const { id } = graphEdge;
  return id;
};
